module.exports = __webpack_public_path__ + "static/media/android.dd3c4b41.png";